import { useForm, SubmitHandler, useWatch } from "react-hook-form";
import { CreateUserDto, UserResDto } from "../../../api/Api";
import useAxios from "axios-hooks";
import { useState } from "react";
import { useParams } from "react-router-dom";

export type MemberInput = {
  name: string;
};

export default function ClassroomForm(props: {
  onSuccess: any;
  defaultValues?: UserResDto;
}) {
  const params = useParams();

  const {
    register,
    control,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<MemberInput>();

  const [
    {
      data: createClassroomData,
      loading: createClassroomLoading,
      error: createClassroomError,
    },
    createClassroom,
  ] = useAxios<any, any>(
    {
      url: "/classrooms",
      method: "POST",
    },
    {
      manual: true,
    }
  );

  const [
    {
      data: updateClassroomData,
      loading: updateClassroomLoading,
      error: updateClassroomError,
    },
    updateClassRoom,
  ] = useAxios<any, any>(
    {
      url: `/classrooms/${params.classroomId}`,
      method: "PATCH",
    },
    {
      manual: true,
    }
  );

  const onSubmit: SubmitHandler<MemberInput> = async (data) => {
    try {
      let response;

      if (props?.defaultValues) {
        response = await updateClassRoom({
          data: data,
        });
      } else {
        response = await createClassroom({
          data: {
            ...data,
          },
        });
      }

      if (response.status === 201) {
        props.onSuccess(response.data);
      }
    } catch (error) {}
  };

  return (
    <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
      <label className="form-control w-full">
        <div className="label">
          <span className="label-text">Name</span>
        </div>

        <input
          // disabled={props?.defaultValues?.name ? true : false}
          {...register("name", {
            required: true,
            // pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i,
          })}
          defaultValue={props?.defaultValues?.name}
          type="text"
          className="input input-bordered input-sm w-full"
        />
        <div className="label">
          {errors?.name?.type === "required" && (
            <span className="label-text-alt text-error">
              This field is required
            </span>
          )}
        </div>
      </label>

      <div className="pt-2 w-full">
        <button
          disabled={updateClassroomLoading}
          className="btn btn-sm  btn-primary"
          type="submit"
        >
          {props.defaultValues ? "Update Info" : "Create"}
        </button>
      </div>

      {createClassroomError && (
        <div className="alert alert-error text-sm mt-6 text-center">
          {createClassroomError?.response?.data?.message}
        </div>
      )}
      {createClassroomLoading && (
        <div className="flex items-center justify-center mt-6">
          <div className="loading loading-spinner "></div>
        </div>
      )}
      {updateClassroomData && (
        <div className="alert alert-success text-sm mt-6 text-center">
          Updated classroom succefully
        </div>
      )}
    </form>
  );
}
